export const toIDRFormat = (data) => {
  return data.toLocaleString("id", {
    style: "currency",
    currency: "IDR",
  })
}